// src/Pages/SignupSuccess.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";
import { useAuthContext } from "../Hooks/useauthContext";
import '../Styles/PaymentSuccess.css';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { dispatch } = useAuthContext();

  useEffect(() => {
    // Extract the session_id from the URL query parameters
    const params = new URLSearchParams(location.search);
    const stripeSessionId = params.get("session_id");
    
    if (stripeSessionId) {
      const finalizeSignup = async () => {
        try {
          const response = await axios.get(`${API_URL}/payment-success`, {
            params: { session_id: stripeSessionId }
          });          
          navigate("/dashboard");
        } catch (err) {
          console.error("Payment finalization failed", err);
          // Optionally, redirect to an error page or display a message.
        }
      };
      finalizeSignup();
    }
  }, [location.search, navigate, dispatch]);

  return (
      <div className="payment-finalizing-container">
          <h2>Finalizing your subscription...</h2>
          <p>Please wait while we complete your payment.</p>
      </div>
  );
};

export default PaymentSuccess;
